import URLSearchParams from 'url-search-params';

var appendToUrl = function appendToUrl(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === void 0 ? true : _ref$replace;

  var hashSplit = url.split('#');
  var hash = hashSplit[1];
  var nonHashUrl = hashSplit[0];
  var paramsSplit = nonHashUrl.split('?');
  var baseUrl = paramsSplit[0];
  var paramsString = paramsSplit[1] || '';
  var urlSearchParams = new URLSearchParams(paramsString);
  Object.keys(params).forEach(function (key) {
    if (!replace && urlSearchParams.has(key)) return;
    var value = params[key];
    urlSearchParams.set(key, value);
  });
  var newParams = urlSearchParams.toString();
  return "".concat(baseUrl, "?").concat(newParams).concat(hash ? "#".concat(hash) : '');
};

export { appendToUrl };
